// Every desktop page, as a tile, on the phone (Ryan, Oct 1 2026: "a tile that gives you
// the full function of the desktop with a tile for each page"). Tapping one switches the
// device to desktop view and opens that page; the desktop's own "Mobile view" switch
// brings you back. The list is the sidebar's own (same access rule) plus everything
// under Administration, so a page added there shows up here on its own.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MobileBottomNav from '../components/MobileBottomNav';
import { setPreferredView } from '../services/viewMode';
import { desktopPagesFor } from './admin/AdminLayout';
import { ADMIN_PAGES } from './admin/AdminAdministration';

const sessionUserId = () => { try { const s = JSON.parse(localStorage.getItem('titan_session') || 'null'); return String(s?.user?.id ?? s?.userId ?? ''); } catch { return ''; } };

function PageTile({ icon, label, color = '#e87722', onClick }) {
  return (
    <button onClick={onClick}
      style={{ textAlign: 'left', background: '#fff', border: '1.5px solid #ececec', borderRadius: 16, padding: '14px 12px', cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 10, minHeight: 104 }}>
      <div style={{ width: 42, height: 42, borderRadius: 12, background: color, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 20 }}>{icon}</div>
      <div style={{ fontSize: 14.5, fontWeight: 800, color: '#111', lineHeight: 1.2 }}>{label}</div>
    </button>
  );
}

export default function DesktopPages() {
  const navigate = useNavigate();
  const { worker } = useAuth();
  const role = worker?.role || 'admin';
  const main = desktopPagesFor(role, sessionUserId()).filter(p => !/preview/.test(p.id));
  const admin = ADMIN_PAGES.filter(p => !p.roles || p.roles.includes(role) || (role === 'Executive' && p.roles.includes('admin')));
  const open = path => { setPreferredView('desktop'); navigate(path); };

  const section = (title, items, render) => items.length > 0 && (
    <div style={{ marginBottom: 22 }}>
      <div style={{ fontSize: 11.5, fontWeight: 800, color: '#8a8a8a', textTransform: 'uppercase', letterSpacing: 0.6, margin: '0 0 10px 2px' }}>{title}</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12 }}>{items.map(render)}</div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f6f5f2', paddingBottom: 90 }}>
      <div style={{ background: '#1c1917', color: '#fff', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate('/dashboard')} style={{ background: 'rgba(255,255,255,0.12)', border: 'none', color: '#fff', borderRadius: 999, padding: '7px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>‹ Home</button>
        <div>
          <div style={{ fontSize: 17, fontWeight: 800 }}>🖥 Desktop pages</div>
          <div style={{ fontSize: 12, opacity: 0.8 }}>Every page the desktop has. Tap one to open it full-size; "Mobile view" on the desktop brings you back.</div>
        </div>
      </div>
      <div style={{ padding: 16 }}>
        {section('Main menu', main, p => <PageTile key={p.id} icon={p.icon} label={p.label} onClick={() => open(p.path)} />)}
        {section('Administration', admin, p => <PageTile key={p.key} icon={p.icon} label={p.label} color={p.color || '#1e3a5f'} onClick={() => open(p.path)} />)}
      </div>
      <MobileBottomNav />
    </div>
  );
}
